/**
 * @generated SignedSource<<b3e73c7b86a60445b4521664ee4a001d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutinesListItemScheduleWeekly_schedule$data = {
  readonly endWeekday: number | null;
  readonly startWeekday: number | null;
  readonly " $fragmentType": "WorkspaceRoutinesListItemScheduleWeekly_schedule";
};
export type WorkspaceRoutinesListItemScheduleWeekly_schedule$key = {
  readonly " $data"?: WorkspaceRoutinesListItemScheduleWeekly_schedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemScheduleWeekly_schedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutinesListItemScheduleWeekly_schedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startWeekday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endWeekday",
      "storageKey": null
    }
  ],
  "type": "RoutineScheduleWeekly",
  "abstractKey": null
};

(node as any).hash = "e823717f2ef6d04bd90318d56282e569";

export default node;
